// import { REGION } from '@eureka/utils/environment';
import type { DeployEnv } from '@patsnap-utils/biz';
type languages = 'en' | 'cn' | 'tw' | 'jp';

export const EXAMPLE_LINKS: Partial<Record<DeployEnv, Partial<Record<languages, string[]>>>> = {
  us: {
    en: [
      'https://eureka.patsnap.com/mse/#/shared/chat/ddac035a-ebc3-4c45-a6e1-c9d853fbf085',
      'https://eureka.patsnap.com/mse/#/shared/chat/94b50985-61e8-4ea1-8799-fb49f6bc02a6',
      'https://eureka.patsnap.com/mse/#/shared/chat/b16006f7-3e51-419a-b98a-617047290f9b',
      'https://eureka.patsnap.com/mse/#/shared/chat/47a515a9-7493-46ef-a213-78c56180f5bc',
      'https://eureka.patsnap.com/mse/#/shared/chat/9225f251-4b5a-4ae4-af4f-3077d995cc4f',
      'https://eureka.patsnap.com/mse/#/shared/chat/b37f7a04-a12a-4a89-8375-db0469c774b2',
      'https://eureka.patsnap.com/mse/#/shared/chat/cfb1bcbe-d338-4196-b84f-4631be15da9e',
    ],
    jp: [
      'https://eureka.patsnap.com/mse/#/shared/chat/ddac035a-ebc3-4c45-a6e1-c9d853fbf085',
      'https://eureka.patsnap.com/mse/#/shared/chat/94b50985-61e8-4ea1-8799-fb49f6bc02a6',
      'https://eureka.patsnap.com/mse/#/shared/chat/b16006f7-3e51-419a-b98a-617047290f9b',
      'https://eureka.patsnap.com/mse/#/shared/chat/47a515a9-7493-46ef-a213-78c56180f5bc',
      'https://eureka.patsnap.com/mse/#/shared/chat/9225f251-4b5a-4ae4-af4f-3077d995cc4f',
      'https://eureka.patsnap.com/mse/#/shared/chat/b37f7a04-a12a-4a89-8375-db0469c774b2',
      'https://eureka.patsnap.com/mse/#/shared/chat/cfb1bcbe-d338-4196-b84f-4631be15da9e',
    ],
    cn: [
      'https://eureka.patsnap.com/mse/#/shared/chat/520189e8-9489-42db-be63-2df34628441b',
      'https://eureka.patsnap.com/mse/#/shared/chat/c0592fc0-5d19-4721-bb02-35482ec09e84',
      'https://eureka.patsnap.com/mse/#/shared/chat/3c6c054d-db34-479b-a1d9-6709a82197e8',
      'https://eureka.patsnap.com/mse/#/shared/chat/70405586-efeb-4388-89a5-b7b08c68a98b',
      'https://eureka.patsnap.com/mse/#/shared/chat/e51187f5-9fb4-4bfe-b92d-736fee95da01',
      'https://eureka.patsnap.com/mse/#/shared/chat/8095c98c-40e1-4b2d-91cb-94df93308042',
      'https://eureka.patsnap.com/mse/#/shared/chat/a2fdbcf0-9e7f-4b8e-b644-85d5d6f6a489',
    ],
    tw: [
      'https://eureka.patsnap.com/mse/#/shared/chat/520189e8-9489-42db-be63-2df34628441b',
      'https://eureka.patsnap.com/mse/#/shared/chat/c0592fc0-5d19-4721-bb02-35482ec09e84',
      'https://eureka.patsnap.com/mse/#/shared/chat/3c6c054d-db34-479b-a1d9-6709a82197e8',
      'https://eureka.patsnap.com/mse/#/shared/chat/70405586-efeb-4388-89a5-b7b08c68a98b',
      'https://eureka.patsnap.com/mse/#/shared/chat/e51187f5-9fb4-4bfe-b92d-736fee95da01',
      'https://eureka.patsnap.com/mse/#/shared/chat/8095c98c-40e1-4b2d-91cb-94df93308042',
      'https://eureka.patsnap.com/mse/#/shared/chat/a2fdbcf0-9e7f-4b8e-b644-85d5d6f6a489',
    ],
  },
  eu: {
    en: [
      'https://eureka.patsnap.eu/mse/#/shared/chat/8e815792-ff19-4cc3-9f37-babef612ff68',
      'https://eureka.patsnap.eu/mse/#/shared/chat/46c46b8f-97e2-42da-a8a0-7305ee9954ce',
      'https://eureka.patsnap.eu/mse/#/shared/chat/4ce1a43c-814a-42ab-b196-57feb0480d29',
      'https://eureka.patsnap.eu/mse/#/shared/chat/b535d9b0-6c19-4991-9a33-6b437777e8da',
      'https://eureka.patsnap.eu/mse/#/shared/chat/f60fde77-568c-4604-9c41-8014efff7902',
      'https://eureka.patsnap.eu/mse/#/shared/chat/33decd08-cfaa-41ef-b9bf-99df9e17e0ea',
      'https://eureka.patsnap.eu/mse/#/shared/chat/616c5083-d86d-4976-9d37-e4eb26bd8fb8',
    ],
    jp: [
      'https://eureka.patsnap.eu/mse/#/shared/chat/8e815792-ff19-4cc3-9f37-babef612ff68',
      'https://eureka.patsnap.eu/mse/#/shared/chat/46c46b8f-97e2-42da-a8a0-7305ee9954ce',
      'https://eureka.patsnap.eu/mse/#/shared/chat/4ce1a43c-814a-42ab-b196-57feb0480d29',
      'https://eureka.patsnap.eu/mse/#/shared/chat/b535d9b0-6c19-4991-9a33-6b437777e8da',
      'https://eureka.patsnap.eu/mse/#/shared/chat/f60fde77-568c-4604-9c41-8014efff7902',
      'https://eureka.patsnap.eu/mse/#/shared/chat/33decd08-cfaa-41ef-b9bf-99df9e17e0ea',
      'https://eureka.patsnap.eu/mse/#/shared/chat/616c5083-d86d-4976-9d37-e4eb26bd8fb8',
    ],
    cn: [
      'https://eureka.patsnap.eu/mse/#/shared/chat/84b81fb3-9423-4fb1-b15f-21dcd4fbb33f',
      'https://eureka.patsnap.eu/mse/#/shared/chat/656dd203-2c13-4c06-bc69-65f2b5c797fd',
      'https://eureka.patsnap.eu/mse/#/shared/chat/3f43fa03-16f9-45a3-acef-87002f756741',
      'https://eureka.patsnap.eu/mse/#/shared/chat/0bebd8d7-133b-4001-9d35-e03db92c833c',
      'https://eureka.patsnap.eu/mse/#/shared/chat/1814122a-279e-4610-bb09-0783caeda4d9',
      'https://eureka.patsnap.eu/mse/#/shared/chat/90663dd7-9ffb-4256-911a-9b41bfd64f3f',
      'https://eureka.patsnap.eu/mse/#/shared/chat/6264d410-6353-4ec4-adc7-ecb1b74b09d4',
    ],
    tw: [
      'https://eureka.patsnap.eu/mse/#/shared/chat/84b81fb3-9423-4fb1-b15f-21dcd4fbb33f',
      'https://eureka.patsnap.eu/mse/#/shared/chat/656dd203-2c13-4c06-bc69-65f2b5c797fd',
      'https://eureka.patsnap.eu/mse/#/shared/chat/3f43fa03-16f9-45a3-acef-87002f756741',
      'https://eureka.patsnap.eu/mse/#/shared/chat/0bebd8d7-133b-4001-9d35-e03db92c833c',
      'https://eureka.patsnap.eu/mse/#/shared/chat/1814122a-279e-4610-bb09-0783caeda4d9',
      'https://eureka.patsnap.eu/mse/#/shared/chat/90663dd7-9ffb-4256-911a-9b41bfd64f3f',
      'https://eureka.patsnap.eu/mse/#/shared/chat/6264d410-6353-4ec4-adc7-ecb1b74b09d4',
    ],
  },
};
